import { GlobalConfig } from "@/interfaces/GlobalConfig";

export function getGlobalConfig(): GlobalConfig {
  const config = {
    locale: "nl",
    fallbackLocale: "en",
  };
  const configElement = document.getElementById("costs-calculator-config");
  if (configElement != null) {
    return JSON.parse(configElement.innerHTML);
  } else {
    return config;
  }
}
